(function () {
    "use strict";

    angular
        .module("app")
        .service("customersService", service);

    function service($http) {
        const self = this;

        self.search = company_name => $http.post("/api/customers/search", JSON.stringify(company_name)).then(res => res.data);
    }
    service.$inject = ["$http"];

})()